var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle-box text-center animated fadeInDown"},[_c('h1',[_vm._v("404")]),_c('h3',{staticClass:"font-bold"},[_vm._v("Page Not Found")]),_c('div',{staticClass:"error-desc"},[_vm._v(" Sorry, but the page you are looking for has note been found. Try checking the URL for error, then hit the refresh button on your browser. ")])])
}]

export { render, staticRenderFns }